export default __webpack_public_path__ + "static/media/FourOFour.ceed938c.svg";